import { ReactNode } from "react";
import "./emptyState.scss";

export interface EmptyStateProps {
  /** What is empty — e.g. "No users yet" or "No results found". */
  title: string;
  /** Optional supporting copy: why it's empty, or what to do next. */
  description?: string;
  /**
   * Optional call to action — e.g. a "New user" `Button` for a genuinely
   * empty resource, or a "Clear search" action for an empty search result.
   */
  action?: ReactNode;
}

/**
 * A generic "nothing to show" panel.
 *
 * Deliberately has no built-in copy or icon: the same `rows.length === 0`
 * state means different things depending on why the list is empty (a
 * company with zero users vs. a search with zero matches), and only the
 * caller knows which one it is. `title`/`description`/`action` are all
 * consumer-supplied so each call site can render the message and action
 * that fits its own case.
 */
const EmptyState = ({ title, description, action }: EmptyStateProps) => (
  <div className="empty-state">
    <p className="empty-state__title">{title}</p>
    {description ? (
      <p className="empty-state__description">{description}</p>
    ) : null}
    {action ? <div className="empty-state__action">{action}</div> : null}
  </div>
);

export default EmptyState;
